<!-- Bouton de changement de langue -->
<button
  pButton
  type="button"
  class="language-switcher__button"
  [label]="currentLanguageLabel"
  icon="pi pi-globe"
  iconPos="left"
  (click)="openLanguageDialog()"
  [attr.aria-label]="'Change language. Current: ' + currentLanguageObject?.name"
  [attr.aria-expanded]="showLanguageDialog"
  aria-haspopup="dialog"
  pRipple>
</button>

<!-- Modale de sélection de langue avec PrimeNG Dialog -->
<p-dialog
  [(visible)]="showLanguageDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [blockScroll]="true"
  [focusOnShow]="true"
  [baseZIndex]="10000"
  [autoZIndex]="true"
  [showHeader]="true"
  [closable]="true"
  styleClass="language-dialog"
  maskStyleClass="language-dialog-mask"
  contentStyleClass="language-dialog-content"
  [breakpoints]="{'960px': '75vw', '640px': '95vw'}"
  [style]="{
    width: '420px',
    maxWidth: '95vw',
    display: 'flex',
    flexDirection: 'column',
    pointerEvents: 'auto',
    zIndex: '11102',
    background: 'white',
    borderRadius: '1em',
    padding: '1em'
  }"
  (onHide)="closeLanguageDialog()"
  appendTo="body">
  
  <!-- Header de la modale -->
  <ng-template pTemplate="header">
    <div class="language-dialog__header">
      <i class="pi pi-globe language-dialog__header-icon" aria-hidden="true"></i>
      <h2 class="language-dialog__title">
        {{ 'COMMON.SELECT_LANGUAGE' | translate }}
      </h2>
    </div>
  </ng-template>

  <!-- Contenu de la modale -->
  <div class="language-dialog__content">
    <div class="language-dialog__description">
      {{ 'COMMON.LANGUAGE_DESCRIPTION' | translate }}
    </div>

    <!-- Liste des langues -->
    <div class="language-list" role="radiogroup" [attr.aria-label]="'Available languages'">
      <button
        *ngFor="let language of languages"
        type="button"
        class="language-item"
        [class.language-item--active]="isActiveLanguage(language.code)"
        (click)="changeLanguage(language.code)"
        [attr.aria-label]="language.name + (isActiveLanguage(language.code) ? ' (current)' : '')"
        [attr.aria-checked]="isActiveLanguage(language.code)"
        role="radio"
        pRipple>
        
        <!-- Drapeau et nom -->
        <div class="language-item__content">
          <span class="language-item__flag" aria-hidden="true">{{ language.flag }}</span>
          <div class="language-item__info">
            <span class="language-item__name">{{ language.name }}</span>
            <span class="language-item__native">{{ language.nativeName }}</span>
          </div>
        </div>

        <!-- Icône de sélection -->
        <i 
          *ngIf="isActiveLanguage(language.code)"
          class="pi pi-check language-item__check"
          aria-hidden="true">
        </i>
      </button>
    </div>

    <!-- Badge de langue actuelle -->
    <div class="language-dialog__current">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      <span>
        {{ 'COMMON.CURRENT_LANGUAGE' | translate }}: 
        <strong>{{ currentLanguageObject?.name }}</strong>
      </span>
    </div>
  </div>

  <!-- Footer de la modale
  <ng-template pTemplate="footer">
    <div class="language-dialog__footer">
      <button
        pButton
        type="button"
        label="{{ 'COMMON.CLOSE' | translate }}"
        icon="pi pi-times"
        class="p-button-text"
        (click)="closeLanguageDialog()"
        [attr.aria-label]="'Close language selection dialog'"
        pRipple>
      </button>
    </div>
  </ng-template> -->
</p-dialog>

